import tw, { styled } from "twin.macro";

import SvgIcon from "../../assets/images/icons/reactivate.inline.svg";

export const ReactivateStylized = styled.span`
  ${tw`text-reactivate font-medium whitespace-nowrap`}
`;

const ReactivateIcon = styled(SvgIcon)`
  display: inline-block;
  height: 1em;
  width: 1em;

  // Place on baseline
  position: relative;
  top: 0.125em;

  flex-shrink: 0;
  fill: currentColor;
  transition: fill 0.3s;

  &.tight-to-label {
    margin-right: -0.125em;
  }
`;

export default ReactivateIcon;
